export function BackgroundOrbs() {
  return (
    <>
      {/* Gradient orbs matching the Figma design */}
      <div 
        className="gradient-orb w-[243px] h-[644px] bg-accent-pink"
        style={{ 
          left: '-51px', 
          top: '1388px',
        }}
      />
      <div 
        className="gradient-orb w-[362px] h-[920px] bg-accent-cyan"
        style={{ 
          left: '192px', 
          top: '363px',
        }}
      />
      <div 
        className="gradient-orb w-[301px] h-[712px] bg-accent-green"
        style={{ 
          left: '168px', 
          top: '1295px',
        }}
      />
      <div 
        className="gradient-orb w-[181px] h-[463px] bg-accent-blue"
        style={{ 
          left: '-34px', 
          top: '656px',
        }}
      />
      <div 
        className="gradient-orb w-[258px] h-[676px]"
        style={{ 
          left: '-76px', 
          top: '-239px',
          background: 'rgba(234, 93, 182, 0.75)',
        }}
      />
    </>
  )
} 